import {
  IconAnalytics,
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconCoil,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingAsset/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingAsset/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingAsset/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingAsset/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingAsset/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingAsset/img/6.avif';
import image7 from '@src/assets/images/solution/manufacturingAsset/img/7.avif';
import image8 from '@src/assets/images/solution/manufacturingAsset/img/8.avif';

export default {
  type: '制造解决方案',
  banner: {
    title: '用AI高效且准确地管理大型物流仓库的库存资产',
    desc: '利用AI视频识别技术，自动识别钢卷等多种物流资产，实现库存管理的高效化与精准化。',
  },

  video: {
    title: '即使在复杂的物流环境中也可通过AI实时管理库存资产',
    desc: '传统的手动盘点在复杂的物流环境下效率低且易出错。ORBRO的AI系统可自动识别如钢卷等多种物流资产，精准管理，提升仓库运营效率。',
    // play: video,
    image: image1,
  },

  func: [
    {
      theme: '通过AI视频分析技术准确管理各种物流资产',
      title: '基于AI视频的资产自动计数',
      desc: 'AI摄像头实时准确识别并自动计数钢卷等多种物流资产。即使在复杂的仓库环境下也可快速、准确地管理库存。',
      sub1: '实时状态监控',
      icon1: IconClockGray,
      sub2: '提供统计数据',
      icon2: IconChartBarGray,
      image: image2,
    },
    {
      title: '钢卷及托盘AI识别与管理',
      desc: '通过AI视频技术准确同时识别钢卷及其托盘，可管理复杂的资产。在多种形态的资产混用情况下也可高效掌握库存状态。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '提供高精度',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '多样资产模型学习与自动管理系统',
      desc: 'AI学习并识别包括钢卷和托盘在内的多种资产模型，实现复杂资产的精准管理。',
      sub1: '标记风险资产',
      icon1: IconWarningGray,
      sub2: '设置响应策略',
      icon2: IconChartRadiusGray,
      image: image4,
    },
    {
      theme: '通过自动化数据分析最大化物流运营效率',
      title: '按区域实时掌握库存状态',
      desc: '即时查看仓库内各区域的库存状态，实现基于数据的精准运营，助力快速决策。',
      sub1: '云端存储数据',
      icon1: IconClockGray,
      sub2: '提供统计数据',
      icon2: IconChartBarGray,
      image: image5,
    },
    {
      title: '追踪与预测分时段库存物流变化',
      desc: '自动记录并分析库存物流量的分时段变化，精准预测物流流向，高效应对。',
      sub1: '标记风险资产',
      icon1: IconWarningGray,
      sub2: '设置响应策略',
      icon2: IconChartRadiusGray,
      image: image6,
    },
    {
      title: '手动库存管理自动化',
      desc: '通过AI自动计数，自动化传统的手动库存管理，显著减少人为错误与时间浪费。',
      sub1: '云端存储数据',
      icon1: IconClockGray,
      sub2: '提供统计数据',
      icon2: IconChartBarGray,
      image: image7,
    },
    {
      title: '导出分析数据CSV文件',
      desc: '可将分析后的库存及物流数据以CSV文件形式轻松导出，便于多种业务报告与深入分析。',
      sub1: '云端存储数据',
      icon1: IconClockGray,
      sub2: '提供统计数据',
      icon2: IconChartBarGray,
      image: image8,
    },
  ],

  system: {
    title: '系统结构',
    img: rtlsSystem,
  },

  productTitle: '产品组合',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: IconAtom,
        title: 'AI自动识别资产',
        desc: '利用AI技术实时自动识别资产，实现高效精准管理。',
      },
      {
        icon: IconCoil,
        title: '钢卷与托盘识别',
        desc: 'AI可同时识别钢卷与托盘，即使在复杂环境中也能准确管理库存。',
      },
      {
        icon: IconLocation,
        title: '资产位置与状态监控',
        desc: '实时分析仓库内资产位置与状态，实现高效管理。',
      },
      {
        icon: IconPenSquare,
        title: '手动库存管理自动化',
        desc: '将传统的手动库存管理自动化，大幅提升工作效率与准确性。',
      },
      {
        icon: IconDashboard,
        title: '实时库存状态仪表盘',
        desc: '提供实时仪表盘，一目了然掌握仓库资产状态。',
      },
      {
        icon: IconRoute,
        title: '资产移动路径分析',
        desc: 'AI分析资产的移动路径及使用模式，助力高效运营规划。',
      },
      {
        icon: IconLayers,
        title: '按区域实时库存管理',
        desc: '实时查看各区域的资产保有情况，精准高效管理。',
      },
      {
        icon: IconChartBar,
        title: '分时段库存变动分析',
        desc: '分析库存的分时段变化，预测物流流向并快速应对。',
      },
      {
        icon: IconSecurity,
        title: 'AI高识别准确率',
        desc: 'AI以超过99%的准确率识别多样资产，提供高可信度数据。',
      },
      {
        icon: IconAnalytics,
        title: '基于运营数据的决策支持',
        desc: '基于分析后的运营数据，支持快速精准决策与策略制定。',
      },
    ],
  },

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
